import { Injectable } from '@angular/core';
import {
    type MapboxMap,
    VehicleType,
} from '@polaris-customerweb/sharedcomponents.core';
import { RideArea } from '@polaris-customerweb/sharedcomponents.map';
import { ConsoleLogService } from '@polaris-customerweb/sharedcomponents.shared';
import { isEmpty } from 'lodash-es';
import type { Point } from 'mapbox-gl';
import { MapContentMapService } from './map-content-map.service';
import { MapService } from './map.service';
import { RideAreaService } from './ride-area.service';

@Injectable({ providedIn: 'root' })
export class RideAreaMapService extends MapContentMapService {
    private initialRideType: VehicleType = 'ORV';

    constructor(
        consoleLogService: ConsoleLogService,
        mapService: MapService,
        private rideAreaService: RideAreaService
    ) {
        super(consoleLogService, mapService);
        super.setSourceId('rideAreas');
    }

    override addSources(mapboxMap: MapboxMap) {
        const layerIds = this.mapService.getLayerIds(mapboxMap);
        this.getLayerIds(layerIds);
        this._layerIdsSelectable = [
            ...this.layerIdsUnselected,
            ...this.layerIdsSelected,
        ];

        this.setRideTypeFilter(mapboxMap, this.initialRideType);
    }

    setRideTypeFilter(mapboxMap: MapboxMap, vehicleType: VehicleType): void {
        if (this.layerIds.length === 0) {
            this.initialRideType = vehicleType;
            return;
        }

        this.layerIds.forEach((layerId) => {
            this.mapService.setVehicleTypeFilter(
                mapboxMap,
                layerId,
                vehicleType
            );
        });
    }

    getRideAreaAtPoint(
        mapboxMap: MapboxMap,
        point: Point
    ): RideArea | undefined {
        const features = this.mapService.getFeaturesAtPoint(
            mapboxMap,
            point,
            this.layerIds
        );
        let rideArea: RideArea | undefined;

        if (!isEmpty(features)) {
            rideArea = this.rideAreaService.getCachedRideArea(
                features[0].properties?.id as string
            );
        }

        return rideArea;
    }
}
